import Image from "next/image";
import Link from "next/link";
import React from "react";
import { Button } from "./ui/button";
import { ArrowLeft } from "lucide-react";
import { useRouter, usePathname } from "next/navigation";
import { getLogo, getStoreName } from "@/services/storeService";

const ExtraNav = () => {
  const router = useRouter();
  const pathname: any = usePathname();

  // Determine text based on URL
  const mobileTitle = pathname.includes("/cart")
    ? "Cart"
    : pathname.includes("/checkout")
      ? "Checkout"
      : "";

  return (
    <div className="!sticky !top-0 z-10">
      <div className=" w-full z-10 bg-white shadow-md flex md:justify-center justify-between px-[16px]">
        <Button
          variant="ghost"
          className="my-auto md:hidden block"
          size="icon"
          onClick={() => router.back()}
        >
          <ArrowLeft className="h-5 w-5" />
          <span className="sr-only">Back</span>
        </Button>
        <div className="block md:block">
          <Link href="/" className="flex items-center gap-2 p-2">
            <img
              className="w-[180px] h-[60px] object-contain"
              src={`${getLogo()}`}
              alt={`${getStoreName()}'s Logo`}
              onError={(e) => {
                e.currentTarget.src =
                  "https://vilva-backup.blr1.digitaloceanspaces.com/vilvabusiness/common%20files/empty-logowebp.webp";
              }}
              width={80}
              height={40}
            />
          </Link>
        </div>
        {/* <div className="block md:hidden my-auto">
          <p>{mobileTitle}</p>
        </div> */}
        <Button
          variant="ghost"
          className="invisible"
          size="icon"
          onClick={() => router.back()}
        >
          <ArrowLeft className="h-5 w-5" />
          <span className="sr-only">Back</span>
        </Button>
      </div>
    </div>
  );
};

export default ExtraNav;
